var map = {
	"./homepage.de-CH.json": 1314,
	"./homepage.de-DE.json": 1315,
	"./homepage.en-CA.json": 1316,
	"./homepage.en-GB.json": 1317,
	"./homepage.en-IN.json": 1318,
	"./homepage.en-ME.json": 1319,
	"./homepage.en-US.json": 1320,
	"./homepage.es-EM.json": 1321,
	"./homepage.es-ES.json": 1322,
	"./homepage.fr-BE.json": 1323,
	"./homepage.fr-CA.json": 1324,
	"./homepage.fr-CH.json": 1325,
	"./homepage.nl-BE.json": 1326,
	"./homepage.nl-NL.json": 1327,
	"./homepage.pl-PL.json": 1328,
	"./homepage.pt-BR.json": 1329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1313;